/**
 * Environment Configuration
 * 
 * Centralized configuration for environment variables.
 * All environment variables must be prefixed with VITE_ to be exposed to the client.
 */

interface AppConfig {
  apiUrl: string;
  keycloak: {
    url: string;
    realm: string;
    clientId: string;
  };
  app: {
    name: string;
    version: string;
    organization: string;
  };
}

export const env: AppConfig = {
  // Backend exposes minimal-api endpoints at /api/{module}/{resource}
  // The base URL includes the /api prefix.
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:18080',
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'erp-system',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'erp-public-client',
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'RS ERP System',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    organization: import.meta.env.VITE_APP_ORGANIZATION || 'RS ERP Organization',
  },
};

// Validate required environment variables
const validateEnv = () => {
  const required = [
    'VITE_API_URL',
    'VITE_KEYCLOAK_URL',
    'VITE_KEYCLOAK_REALM',
    'VITE_KEYCLOAK_CLIENT_ID',
  ];

  const missing = required.filter((key) => !import.meta.env[key]);

  if (missing.length > 0 && import.meta.env.PROD) {
    console.warn(
      `Missing environment variables: ${missing.join(', ')}. Using defaults.`
    );
  }
};

validateEnv();
